"use client";
import { Pagination } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorWhite, ColorCostcoBlue, SpaceXs, FontSize200, FontSize700 } from "@nxt-costco-com/forge-design-tokens";
const StyledPagination = styled(Pagination)(() => ({
  ".Mui-disabled": {
    visibility: "hidden"
  },
  ".MuiPaginationItem-icon": {
    color: ColorCostcoBlue,
    fontSize: FontSize700
  },
  ".MuiPaginationItem-root": {
    borderRadius: 2
  },
  ".MuiPaginationItem-root:hover": {
    background: "transparent"
  },
  ".Mui-selected:hover": {
    color: ColorCostcoBlue,
    fontSize: FontSize200
  },
  ".MuiPaginationItem-page": {
    color: ColorCostcoBlue,
    fontSize: FontSize200,
    marginLeft: SpaceXs,
    marginRight: SpaceXs
  },
  ".MuiPaginationItem-page:hover": {
    background: "transparent"
  },
  ".MuiPaginationItem-page.Mui-selected": {
    borderRadius: 2,
    backgroundColor: `${ColorCostcoBlue} !important`,
    color: ColorWhite
  },
  ".MuiPaginationItem-page.Mui-selected:focused": {
    background: "red"
  }
}));
export {
  StyledPagination
};
